import { render, staticRenderFns } from "./consultation.vue?vue&type=template&id=eaaf3980&scoped=true"
import script from "./consultation.vue?vue&type=script&lang=js"
export * from "./consultation.vue?vue&type=script&lang=js"
import style0 from "./consultation.vue?vue&type=style&index=0&id=eaaf3980&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaaf3980",
  null
  
)

export default component.exports